import styled from 'styled-components'

export const TableStyle = styled.table`
  border-collapse: collapse;
  margin-top: 10px;

  th,
  td {
    padding: 5px;
    border: ${({ theme }) => {
      return theme.border
    }};
    text-align: center;
    font-size: ${({ theme }) => {
      return theme.fonts.size.normal
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin
    }};
    background-color: ${({ theme }) => {
      return theme.colors.white
    }};
  }

  th {
    background-color: ${({ theme }) => {
      return theme.colors.darkPrimary
    }};
    color: ${({ theme }) => {
      return theme.colors.white
    }};
  }

  @media screen and (max-width: 720px) {
    display: none;
  }
`
